import React from 'react';
import Menu from "../components/menu";
import Footer from "../components/footer";

const Terms: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      <Menu />
      <div className="flex-1 container mx-auto p-6">
        <h1 className="text-4xl font-bold text-center text-gray-800 mb-8">Termes et Conditions</h1>
        <div className="bg-white p-8 rounded-lg shadow-lg">
          <section className="mb-8">
            <h2 className="text-3xl font-semibold text-gray-800 mb-4 flex items-center">
              Conditions d'Utilisation de TournoisPadel
            </h2>
            <p className="text-gray-700 leading-relaxed">
              1. <strong>Préambule</strong><br />
              Bienvenue sur TournoisPadel ! En utilisant notre site web et nos services, vous acceptez les présentes conditions générales d'utilisation. Nous vous encourageons à lire attentivement ce document afin de comprendre vos droits et obligations en tant qu'utilisateur.
            </p>
          </section>
          <hr className="my-8" />
          <section className="mb-8">
            <p className="text-gray-700 leading-relaxed">
              2. <strong>Définitions</strong><br />
              Dans ces conditions d'utilisation :
              <ul className="list-disc list-inside ml-4">
                <li><strong>"Site"</strong> désigne le site internet de TournoisPadel accessible à l'adresse [www.tournoispadel.fr].</li>
                <li><strong>"Utilisateur"</strong> désigne toute personne qui accède au site ou utilise les services proposés.</li>
                <li><strong>"Services"</strong> inclut la consultation des tournois, la mise en relation entre joueurs, les notifications, et tout autre service fourni par TournoisPadel.fr.</li>
              </ul>
            </p>
          </section>
          <hr className="my-8" />
          <section className="mb-8">
            <p className="text-gray-700 leading-relaxed">
              3. <strong>Accès au Site</strong><br />
              Le site est accessible gratuitement à tout utilisateur disposant d'une connexion Internet. Certains services, notamment les fonctionnalités Premium, nécessitent un abonnement payant.<br />
              TournoisPadel se réserve le droit de suspendre ou de limiter l'accès au site en cas de maintenance ou de mise à jour.
            </p>
          </section>
          <hr className="my-8" />
          <section className="mb-8">
            <p className="text-gray-700 leading-relaxed">
              4. <strong>Création de Compte</strong><br />
              Pour accéder à certaines fonctionnalités, l'utilisateur doit créer un compte en fournissant des informations personnelles exactes et à jour.<br />
              L'utilisateur s'engage à maintenir la confidentialité de son identifiant et de son mot de passe.<br />
              Toute activité effectuée sur le site avec vos identifiants est sous votre responsabilité.<br />
              TournoisPadel se réserve le droit de suspendre ou de supprimer un compte en cas de non-respect des présentes conditions.
            </p>
          </section>
          <hr className="my-8" />
          <section className="mb-8">
            <p className="text-gray-700 leading-relaxed">
              5. <strong>Utilisation des Services</strong><br />
              En utilisant le site, l'utilisateur s'engage à :
              <ul className="list-disc list-inside ml-4">
                <li>Ne pas utiliser le site à des fins illégales ou contraires à l'ordre public.</li>
                <li>Fournir des informations véridiques dans son profil et lors de toute interaction sur la plateforme.</li>
                <li>Respecter les autres utilisateurs, notamment dans les échanges via la messagerie ou les commentaires.</li>
              </ul>
              TournoisPadel se réserve le droit de modérer ou de supprimer tout contenu inapproprié.
            </p>
          </section>
          <hr className="my-8" />
          <section className="mb-8">
            <p className="text-gray-700 leading-relaxed">
              6. <strong>Abonnements Premium</strong><br />
              TournoisPadel propose une offre Premium permettant d'accéder à des fonctionnalités avancées (détails des tournois, notifications, mise en relation).<br />
              Le coût de l'abonnement est de 5€ par mois.<br />
              L'abonnement est renouvelé automatiquement chaque mois, sauf résiliation par l'utilisateur.<br />
              L'utilisateur peut résilier son abonnement à tout moment via son compte. Aucun remboursement des périodes déjà payées ne sera effectué.
            </p>
          </section>
          <hr className="my-8" />
          <section className="mb-8">
            <p className="text-gray-700 leading-relaxed">
              7. <strong>Responsabilités</strong><br />
              <strong>Responsabilité de TournoisPadel :</strong> Nous nous engageons à fournir des informations précises et à maintenir la disponibilité du site. Toutefois, nous ne garantissons pas l'absence totale d'erreurs ou d'interruptions.<br />
              <strong>Responsabilité de l'utilisateur :</strong> Vous êtes responsable de l'utilisation que vous faites du site et des informations partagées. TournoisPadel décline toute responsabilité en cas de litige entre utilisateurs.
            </p>
          </section>
          <hr className="my-8" />
          <section className="mb-8">
            <p className="text-gray-700 leading-relaxed">
              8. <strong>Propriété Intellectuelle</strong><br />
              Tous les contenus présents sur le site (textes, images, logos, vidéos, etc.) sont la propriété exclusive de TournoisPadel ou de ses partenaires.<br />
              Toute reproduction, modification ou distribution de ces contenus sans autorisation préalable est strictement interdite.
            </p>
          </section>
          <hr className="my-8" />
          <section className="mb-8">
            <p className="text-gray-700 leading-relaxed">
              9. <strong>Données Personnelles</strong><br />
              Le traitement des données personnelles est régi par notre Politique de Confidentialité. En utilisant le site, vous acceptez que vos données soient collectées et utilisées conformément à cette politique.
            </p>
          </section>
          <hr className="my-8" />
          <section className="mb-8">
            <p className="text-gray-700 leading-relaxed">
              10. <strong>Modifications des Conditions d'Utilisation</strong><br />
              TournoisPadel se réserve le droit de modifier ces conditions d'utilisation à tout moment. Les utilisateurs seront informés des changements via une notification sur le site ou par e-mail.
            </p>
          </section>
          <hr className="my-8" />
          <section className="mb-8">
            <p className="text-gray-700 leading-relaxed">
              11. <strong>Résiliation</strong><br />
              TournoisPadel se réserve le droit de suspendre ou de résilier l'accès d'un utilisateur en cas de non-respect des présentes conditions.<br />
              L'utilisateur peut également demander la suppression de son compte à tout moment en contactant le support.
            </p>
          </section>
          <hr className="my-8" />
          <section className="mb-8">
            <p className="text-gray-700 leading-relaxed">
              12. <strong>Contact</strong><br />
              Pour toute question ou réclamation relative à ces conditions d'utilisation, vous pouvez nous contacter :
              <ul className="list-disc list-inside ml-4">
                <li>Par e-mail : <a href="mailto:contact@tournoispadel.fr" className="text-blue-500 underline">contact@tournoispadel.fr</a></li>
              </ul>
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Terms;